import SocialAttendanceTypeRepository from '@/shared/http/repositories/socialProject/social-attendance-type'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import Pagination from '@/components/layout/Pagination/pagination.vue'
import Search from '@/components/layout/Search/search.vue'
import fab from 'vue-fab'
import Roles from '@/shared/mixins/hasRoles'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'TipoDeAtendimentoSocial',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [Pagination.name]: Pagination,
    [Search.name]: Search,
    fab
  },

  mixins: [Roles],

  data: () => ({
    socialAttendanceTypes: [],
    labelSearch: 'Tipos de Atendimento Social',
    showModalAttendanceType: false,
    title: 'Novo Tipo de Atendimento Social',
    id: null,
    searchText: null,
    fields: [
      {
        key: 'name',
        label: 'TIPOS DE ATENDIMENTO SOCIAL',
        class: 'left-header-border text-center'
      },
      {
        key: 'action',
        label: 'AÇÕES',
        class: 'right-header-border text-center'
      }
    ],
    pagination: {
      count: 1,
      limit: 10,
      index: 1
    }
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Tipo de Atendimento Social',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getAll()
  },

  methods: {
    getAll() {
      loading.push()
      SocialAttendanceTypeRepository.GetAll(this.searchText, this.pagination)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.socialAttendanceTypes = res.data.data
          this.pagination = {
            count: res.data.count,
            limit: res.data.pagingLimit,
            index: res.data.pagingIndex
          }
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tipo de atendimento social', 'ERRO')
        })
    },

    search(searchText) {
      this.searchText = searchText
      this.getAll()
    },

    onDelete() {
      loading.push()
      SocialAttendanceTypeRepository.Delete(this.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.getAll()
          this.showModalAttendanceType = false
          toast.success('Tipo de Atendimento Social excluído com sucesso!', 'EXCLUSÃO DE TIPO DE ATENDIMENTO SOCIAL')
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao excluir tipo de atendimento social', 'ERRO')
        })
    },

    selectRow(id) {
      this.showModalAttendanceType = true
      this.id = id
    }
  }
}
